import { ComponentPropsWithRef } from 'react';
import { useCreatorConfig } from '../../../providers/ConfigProvider';
import classNames from '../../../utils/classNames.ts';

export const SecondaryText = ({
    isSelected,
    inlineBlock,
    isOnThumbnail,
    block,
    className,
    style,
    children,
    ref,
    ...props
}: ComponentPropsWithRef<'span'> & {
    isSelected?: boolean;
    inlineBlock?: boolean;
    isOnThumbnail?: boolean;
    block?: boolean;
}) => {
    const { theme } = useCreatorConfig();
    const secondaryTextColour = isOnThumbnail
        ? theme?.colours?.secondaryTextOnThumbnailColour || theme?.colours?.secondaryTextColour
        : theme?.colours?.secondaryTextColour;

    return (
        <span
            style={{
                color: isSelected ? theme?.colours?.primaryColour : secondaryTextColour,
                ...style,
            }}
            className={classNames(className, inlineBlock && 'inline-block', block && 'block')}
            {...props}
            ref={ref}>
            {children}
        </span>
    );
};

export default SecondaryText;
